module.exports = __webpack_public_path__ + "assets/60fe942dff52fcab85a4488b0721692e.png";